import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

export const SUPPORTED_LANGUAGES = ['fr', 'en', 'it', 'de', 'pt', 'es'] as const;

const stored = typeof window !== 'undefined' ? window.localStorage.getItem('monexa_lang') : null;
const detected =
  stored && (SUPPORTED_LANGUAGES as readonly string[]).includes(stored) ? stored : 'fr';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: detected,
    fallbackLng: 'fr',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    nonExplicitSupportedLngs: true,
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;